var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46693 6.49977L6.06693 8.66644L9.53359 4.33311M6.50026 12.5664C5.70357 12.5664 4.91469 12.4095 4.17865 12.1046C3.44261 11.7998 2.77382 11.3529 2.21048 10.7896C1.64714 10.2262 1.20027 9.55743 0.895391 8.82139C0.590513 8.08534 0.433594 7.29646 0.433594 6.49977C0.433594 5.70309 0.590513 4.9142 0.895391 4.17816C1.20027 3.44212 1.64714 2.77333 2.21048 2.20999C2.77382 1.64665 3.44261 1.19978 4.17865 0.894903C4.91469 0.590024 5.70357 0.433105 6.50026 0.433105C8.10924 0.433105 9.65232 1.07227 10.79 2.20999C11.9278 3.34771 12.5669 4.89079 12.5669 6.49977C12.5669 8.10875 11.9278 9.65183 10.79 10.7896C9.65232 11.9273 8.10924 12.5664 6.50026 12.5664Z",
    stroke: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.c2e03e40538f66586fd387a3ce8d2b2c.svg";
export { ForwardRef as ReactComponent };